import type { AdminCrewReportMetricCardProps } from "../../models/admin-crew-report.models";
import { ADMIN_CREW_REPORT_STATISTICS_TITLE_CLASS_NAME } from "../../utils/admin-crew-report.constants";

const AdminCrewReportMetricCard = ({
  title,
  value,
  unit,
  fractionDigits,
  dataTestId,
}: AdminCrewReportMetricCardProps) => {
  const formattedValue = value === null ? "—" : value.toFixed(fractionDigits);
  const accessibleValue = value === null ? "unavailable" : `${formattedValue} ${unit}`;

  return (
    <article
      aria-label={`${title}: ${accessibleValue}`}
      data-test={dataTestId}
      data-testid={dataTestId}
      className="flex min-h-0 min-w-0 flex-col items-center border border-[#D8E6E3] bg-white px-2 pb-3 pt-[11px] text-center dark:border-gray-700 dark:bg-gray-800"
    >
      <h3 className={ADMIN_CREW_REPORT_STATISTICS_TITLE_CLASS_NAME}>{title}</h3>
      <div className="flex flex-1 flex-col items-center justify-center">
        <p className="text-2xl font-semibold tabular-nums leading-none text-green">{formattedValue}</p>
        {value !== null && <p className="mt-1 text-[11px] leading-3 text-[#65706F] dark:text-gray-400">{unit}</p>}
      </div>
    </article>
  );
};

export default AdminCrewReportMetricCard;
